import {NavLink} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers, faSignOutAlt, faLayerGroup, faCogs } from '@fortawesome/free-solid-svg-icons'
import {Box } from '@mui/material';
import { ReactComponent as AmazingCoLogo } from '../assets/archi-new.svg';
import { isSuperAdmin } from 'utils';
import useToken from './useToken';
import { Loyalty } from '@mui/icons-material';




function SidePanel() {
    const { token } = useToken();
    const isSAdmin = isSuperAdmin(token);
    return (
        <Box sx={{ backgroundColor : '#434f69', display : 'flex', height:1}}>
        <div className="SidePanel SidePanel--wrapper">
        <div className="SidePanel--Logo"><NavLink to="/"><AmazingCoLogo /></NavLink></div>
        <NavLink activeClassName="active" to="/customer/"><div className="SidePanel--Button"><FontAwesomeIcon icon={faUsers} title='Customers'/></div></NavLink>
        <NavLink activeClassName="active" to="/bundles/"><div className="SidePanel--Button"><FontAwesomeIcon icon={faLayerGroup} title='Bundles'/></div></NavLink>
        <NavLink activeClassName="active" to="/subscription/"><div className="SidePanel--Button"><Loyalty style={{ width: '20px'}} /></div></NavLink>
        {isSAdmin && <NavLink activeClassName="active" to="/settings/"><div className="SidePanel--Button"><FontAwesomeIcon icon={faCogs} title='Settings'/></div></NavLink>}
        <div className="SidePanel--Button SidePanel--Bottom"><NavLink activeClassName="active" to="/logout"><FontAwesomeIcon icon={faSignOutAlt} title="Log Out"/></NavLink></div>
        </div>
        </Box>
    )
}

export default SidePanel;